// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3bURA","question":"Question_question__1nVEW","description":"Question_description__2Nr3X"};